import { render, staticRenderFns } from "./SelectAddressDialog.vue?vue&type=template&id=1d57527c&"
import script from "./SelectAddressDialog.vue?vue&type=script&lang=js&"
export * from "./SelectAddressDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectAddressDialog.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports